export const MODAL_TYPES = {
  ADD_BANK: 'ADD_BANK',
  ADD_PAYEE: 'ADD_PAYEE',
  EDIT_PAYEE: 'EDIT_PAYEE',
  ADD_BANK_AND_PAYEE: 'ADD_BANK_AND_PAYEE',
  ADD_PAYEE_WITHOUT_IMAGE_MODAL: 'ADD_PAYEE_WITHOUT_IMAGE_MODAL'
};

export const PAYEE_TYPES = {
  PERSON: 'person',
  BUSINESS: 'business'
};

export const PAYEE_ACCOUNT_TYPES = {
  CHECKING: 'checking',
  SAVING: 'savings'
};
